module.exports = flarum.core.compat['components/AffixedSidebar'];